<template>
  <BaseDialog
    :title="$t('survey.editReccurence')"
    :is-open="isOpen"
    type="responsive"
    :align-dismiss-button-right="true"
    @close="closeDialog"
  >
    <CoachSurveyScheduleForm
      v-model:is-recurring="formData.isRecurring"
      v-model:recurrence-interval="formData.recurrenceInterval"
      v-model:recurrence-frequency="formData.recurrenceFrequency"
      v-model:next-occurrence-at="formData.nextOccurrenceAt"
      :recurrence-interval-error="errors.get('recurrenceInterval')"
      :next-occurrence-at-error="errors.get('nextOccurrenceAt')"
      :min-date="minNextOccurrenceAt"
    />
    <template #confirm>
      <BaseTextButton
        color="filled"
        size="M"
        :disabled="isSaving || !isFormValid"
        @click="saveSurveyEdits"
      >
        {{ $t('common.save') }}
      </BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton color="text" size="M" :disabled="isSaving" @click="closeDialog">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script setup lang="ts">
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import { useEditCoachSurvey } from '../composables/use-edit-coach-survey'
  import type { CoachSurvey } from '../composables/use-coach-survey'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import CoachSurveyScheduleForm from './CoachSurveyScheduleForm.vue'
  import { computed, watch } from 'vue'

  interface Props {
    isOpen: boolean
    survey: CoachSurvey
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close-dialog'): void
    (e: 'survey-updated'): void
  }>()

  const closeDialog = () => {
    emit('close-dialog')
    resetForm()
  }

  watch(
    () => props.isOpen,
    () => {
      resetForm()
    },
  )

  const { isFormValid, saveSurveyEdits, resetForm, formData, errors, isSaving, minNextOccurrenceAt } =
    useEditCoachSurvey(
      computed(() => props.survey),
      () => {
        emit('survey-updated')
        closeDialog()
      },
    )
</script>
